var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"space-between"}},[_c('h1',{staticClass:"mb-5 title-project"},[_vm._v("Kanban dashboard")])]),_c('ProjectList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }